import { useTranslation } from "react-i18next"
import { Input } from "@/components/ui/input"
import type { BetterDocSpecialty } from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"

export const DeFixedBetterDocSpecialtyField = ({ specialtyName }: { specialtyName: BetterDocSpecialty }) => {
  const { t } = useTranslation()

  return (
    <Input
      label={t("episodeOfCare.progressNote.pointOfCare.specialty")}
      value={t(`episodeOfCare.betterDoc.searchDialog.specialties.${specialtyName}`)}
      disabled
      testId="better-doc-specialty-field"
    />
  )
}
